import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import LocationDTO from '../../../../dto/LocationDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';

export default function LocationForm(props) {
  const { control, formMeta } = props;
  const dto = new LocationDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_external_id}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_terminal_id}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.vehicle_datetime_at}
          variant="material"
        />
      </Row>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_latitude}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_longitude}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_speed}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_travel_angle}
          variant="material"
        />
      </Row>
    </>
  );
}
